/*
*
 */
import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose } from 'recompose';


import JobInvoiceReview from './JobInvoiceReview';
import DeferredJobReview from './DeferredJobReview';

const propTypes = exact({
  jobView: PropTypes.bool.isRequired,
  deferredJobView: PropTypes.bool.isRequired,
});


const InvoiceReview = (props) => {
  const { jobView, deferredJobView } = props;

  return (
    <div>
      {jobView && <JobInvoiceReview />}
      {deferredJobView && <DeferredJobReview />}
    </div>
  );
};


InvoiceReview.propTypes = propTypes;


const mapStateToProps = (state) => {
  return {
    jobView: state.ticketInvoicing.jobView,
    deferredJobView: state.ticketInvoicing.deferredJobView,
  };
};


const withRedux = connect(mapStateToProps, {});


const enhance = compose(withRedux);


export default enhance(InvoiceReview);
